<template>
    <div class="table">
        <div class="container">
            <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList('search')">
                <el-form-item label="部门名称">
                    <el-input v-model="dataForm.departName" onkeypress="if(event.keyCode == 13) return false;"
                              placeholder="请输入部门名称" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="getDataList('search')" icon="el-icon-search">查询</el-button>
                    <el-button type="primary" @click="addOrUpdateHandle()"
                               v-if="isAuth('department-add')">新增
                    </el-button>
                    <el-button type="danger" @click="deleteHandle()"
                               v-if="isAuth('department-delete')"
                               :disabled="dataListSelections.length <= 0">批量删除
                    </el-button>
                </el-form-item>
            </el-form>
            <el-table
                    :data="dataList"
                    border
                    v-loading="dataListLoading"
                    @selection-change="selectionChangeHandle"
                    style="width: 100%;">
                <el-table-column
                        type="selection"
                        header-align="center"
                        align="center"
                        width="50">
                </el-table-column>
                <el-table-column
                        prop="id"
                        header-align="center"
                        align="center"
                        width="80"
                        label="编号">
                </el-table-column>
                <el-table-column
                        prop="departName"
                        header-align="center"
                        align="center"
                        :show-overflow-tooltip="true"
                        label="部门名称">
                </el-table-column>
                <el-table-column
                        prop="creationDate"
                        header-align="center"
                        align="center"
                        :show-overflow-tooltip="true"
                        label="创建时间">
                </el-table-column>
                <el-table-column
                        fixed="right"
                        header-align="center"
                        align="center"
                        width="200"
                        label="操作">
                    <template slot-scope="scope">
                        <el-button type="primary" icon="el-icon-edit" size="small"
                                   v-if="isAuth('department-edit')"
                                   @click="addOrUpdateHandle(scope.row.id)">编辑
                        </el-button>
                        <el-button type="danger" icon="el-icon-delete" size="small"
                                   v-if="isAuth('department-delete')"
                                   @click="deleteHandle(scope.row.id)">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    @size-change="sizeChangeHandle"
                    @current-change="currentChangeHandle"
                    :current-page="pageIndex"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    :total="totalPage"
                    layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
        </div>
        <depart-add-or-update v-if="addOrUpdateVisible" ref="depart"
                              @getDataList="getDataList()"></depart-add-or-update>
    </div>
</template>

<script>
    import DepartAddOrUpdate from './depart-add-or-update';
    import {Depart} from "../../api/depart";

    export default {
        name: "department",
        data() {
            return {
                dataForm: {
                    departName: ''
                },
                dataList: [],
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                dataListLoading: false,
                dataListSelections: [],
                addOrUpdateVisible: false
            }
        },
        components: {
            DepartAddOrUpdate
        },
        created() {
            this.getDataList();
        },
        activated() {
            this.getDataList();
        },
        computed: {},
        methods: {
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val;
                this.pageIndex = 1;
                this.getDataList();
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val;
                this.getDataList();
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val;
            },
            /**
             * 获取数据
             */
            getDataList(type) {
                this.dataListLoading = true;
                if (type === 'search') {
                    this.pageIndex = 1;
                }
                let params = {
                    'pageIndex': this.pageIndex,
                    'limit': this.pageSize,
                    'departName': this.dataForm.departName
                };
                Depart.getDepartList(params).then(res => {
                    if (res.code === 0) {
                        this.dataList = res.page.list;
                        this.totalPage = res.page.totalCount;
                    }
                    this.dataListLoading = false;
                });
            },
            /**
             * 添加或编辑
             * @param id
             */
            addOrUpdateHandle(id) {
                this.addOrUpdateVisible = true;
                this.$nextTick(() => {
                    this.$refs.depart.init(id)
                })
            },
            /**
             * 删除
             */
            deleteHandle(id) {
                let ids = id ? id.toString() : this.dataListSelections.map(item => item.id).join();
                //console.log(ids)
                let arrayIds = {'ids': ids};
                this.$confirm('此操作将删除部门信息, 确定吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    Depart.deleteDepart(arrayIds).then(res => {
                        if (res.code === 0) {
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration: 1500,
                                onClose: () => {
                                    this.$nextTick(() => {
                                        this.getDataList();
                                    })
                                }
                            })
                        }
                    })
                }).catch(() => {
                })
            }
        }
    }
</script>

<style scoped>
    .el-table::before {
        z-index: inherit;
    }

    .el-pagination {
        margin-top: 30px;
    }
</style>
